export type MapStyle = 'explore' | 'explore_logistics' | 'explore_truck' | 'satellite' | 'satellite_logistics' | 'satellite_truck'

export const MAP_STYLES = {
  day: {
    explore: '&style=explore.day',
    explore_logistics: '&style=logistics.day',
    explore_truck: '&style=logistics.day&features=vehicle_restrictions:active_and_inactive',

    satellite: '&style=explore.satellite.day',
    satellite_logistics: '&style=logistics.satellite.day',
    satellite_truck: '&style=logistics.satellite.day&features=vehicle_restrictions:active_and_inactive',
  },
  night: {
    explore: '&style=explore.night',
    explore_logistics: '&style=logistics.night',
    explore_truck: '&style=logistics.night&features=vehicle_restrictions:active_and_inactive',

    satellite: '&style=explore.satellite.day',
    satellite_logistics: '&style=logistics.satellite.day',
    satellite_truck: '&style=logistics.satellite.day&features=vehicle_restrictions:active_and_inactive',
  },
}